import _taggedTemplateLiteral from "/runner/_work/developers/developers/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";
import _defineProperty from "/runner/_work/developers/developers/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
var _buttonSizesStyle, _templateObject, _templateObject2;
var _ = function _(t) {
    return t;
  },
  _t,
  _t2;
import { GRID_UNIT } from "../../constants/design";
import { fontSize, lineHeight, fontWeight } from "../../constants/typography";
import mediaqueries from "../../util/mediaqueries";
import { NeutralColors } from "../../constants/colors";
import { Palette } from "../../constants/palettes";
import styled, { css } from 'styled-components';
import { ButtonSize, ButtonVariant } from "./types";
var smallFontSize = css(["font-size:", ";line-height:", ";"], fontSize.x2Small, lineHeight.large);
var regularFontSize = css(["font-size:", ";line-height:", ";"], fontSize.small, lineHeight.large);
var buttonSizesStyle = (_buttonSizesStyle = {}, _defineProperty(_buttonSizesStyle, ButtonSize.Small, css(["padding:3px 10px;", ";border-radius:6px;"], smallFontSize)), _defineProperty(_buttonSizesStyle, ButtonSize.Medium, css(["padding:8px 16px;", ";border-radius:10px;"], regularFontSize)), _defineProperty(_buttonSizesStyle, ButtonSize.Large, css(["padding:12px 24px;", ";border-radius:12px;"], regularFontSize)), _buttonSizesStyle);
var getMinWidth = function getMinWidth(_ref) {
  var variant = _ref.variant,
    size = _ref.size,
    hasMinWidth = _ref.hasMinWidth;
  if (variant === ButtonVariant.Tertiary || hasMinWidth === false) {
    return 'auto';
  }
  if (size === ButtonSize.Small) {
    return '64px';
  }
  if (size === ButtonSize.Medium) {
    return '140px';
  }
  return '160px';
};
export var getColorStyle = function getColorStyle(_ref2) {
  var variant = _ref2.variant,
    palette = _ref2.palette;
  var isPositivePalette = palette !== Palette.Negative;
  var colorFromPalette = isPositivePalette ? NeutralColors.Ink : NeutralColors.White;
  var oppositeColorFromPalette = isPositivePalette ? NeutralColors.White : NeutralColors.Ink;
  if (variant === ButtonVariant.Primary) {
    return css(["background:", ";color:", ";border:1px solid ", ";"], colorFromPalette, oppositeColorFromPalette, colorFromPalette);
  }
  if (variant === ButtonVariant.Secondary) {
    return css(["background:transparent;color:", ";border:1px solid ", ";"], colorFromPalette, colorFromPalette);
  }
  if (variant === ButtonVariant.Tertiary) {
    return css(["background:transparent;color:", ";border:none;padding-left:0;padding-right:0;text-decoration:underline;"], colorFromPalette);
  }
};
export var ButtonWrapper = styled.div.withConfig({
  componentId: "sc-16u41sg-0"
})(["display:inline-flex;flex-direction:column;align-items:stretch;gap:", "px;background-color:transparent;min-width:", ";max-width:100%;width:100%;", " ", ""], GRID_UNIT * 2, function (_ref3) {
  var variant = _ref3.variant,
    size = _ref3.size,
    hasMinWidth = _ref3.hasMinWidth;
  return getMinWidth({
    variant: variant,
    size: size,
    hasMinWidth: hasMinWidth
  });
}, mediaqueries.sm(_t || (_t = _(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    gap: ", "px;\n  "])), 0)), GRID_UNIT), mediaqueries.xs(_t2 || (_t2 = _(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    width: ", ";\n  "])), 0)), function (_ref4) {
  var fullWidth = _ref4.fullWidth;
  return fullWidth ? '100%' : 'auto';
}));
export var ButtonElement = styled.button.withConfig({
  componentId: "sc-16u41sg-1"
})(["display:inline-block;border-radius:6px;cursor:pointer;font-family:inherit;transition:all 0.2s ease-out;transition-property:background-color,border-color,color,opacity;justify-content:center;text-align:center;font-weight:", ";width:100%;", ";", ";:hover{opacity:0.8;}"], fontWeight.medium, function (_ref5) {
  var size = _ref5.size;
  var _buttonSizesStyle$siz;
  return (_buttonSizesStyle$siz = buttonSizesStyle[size]) !== null && _buttonSizesStyle$siz !== void 0 ? _buttonSizesStyle$siz : buttonSizesStyle[ButtonSize.Large];
}, function (_ref6) {
  var palette = _ref6.palette,
    variant = _ref6.variant;
  return getColorStyle({
    palette: palette,
    variant: variant
  });
});
export var ButtonHelperText = styled.span.withConfig({
  componentId: "sc-16u41sg-2"
})(["font-size:", ";font-weight:", ";color:", ";line-height:", ";text-align:center;", ""], fontSize.x2Small, fontWeight.regular, NeutralColors.Grey700, lineHeight.large, function (_ref7) {
  var palette = _ref7.palette;
  return palette === Palette.Negative && css(["color:", ";"], NeutralColors.Grey600);
});